import { render, staticRenderFns } from "./orderContent.vue?vue&type=template&id=547b7de0&scoped=true&"
import script from "./orderContent.vue?vue&type=script&lang=js&"
export * from "./orderContent.vue?vue&type=script&lang=js&"
import style0 from "./orderContent.vue?vue&type=style&index=0&id=547b7de0&scoped=true&lang=less&"
import style1 from "./orderContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547b7de0",
  null
  
)

export default component.exports